export default __webpack_public_path__ + "images/assets/4d4adf974727eb5f8bc4e3d890dd383c.svg";